// extracted by mini-css-extract-plugin
export default {"message":"KH02x","content":"uOu9d","iconWrapper":"ISc3J","icon":"fqawR","text":"l_0uV","success":"zvhKP","error":"BnZWM","title":"WnxNo"};